<template>
  <div id="paypal-button"></div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "paypal_button",
  mixins: [bus_common],
  props: ["import", "description"],

  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
mounted() {
  const self = this;
  const totalImport = this.import;

  paypal.Buttons({
    locale: "en_US",

    style: {
      layout: "vertical",
      color: "gold",
      shape: "pill",
      label: "pay"
    },

    createOrder: function (data, actions) {
      return actions.order.create({
        purchase_units: [
          {
            description: self.description,
            amount: {
              currency_code: "USD",
              value: String(totalImport)
            }
          }
        ]
      });
    },

    onApprove: function (data, actions) {
      return actions.order.capture().then(function (details) {
        console.log("approved and captured!", details);

        let pl = {
          regstId: self.$store.state.regstId,
          amount: parseFloat(totalImport),
          paypalOrderId: data.orderID
        };

        self.$emit("paypal_done", pl);
      });
    },

    onError: function (err) {
      console.error("PayPal error", err);
    },

    onCancel: function (data) {
      console.log("PayPal payment cancelled", data);
    }
  }).render("#paypal-button");

  console.log("PayPal button loaded");
}
};
</script>
